import React, { FC } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import {
  ExternalOverviewStats,
  GroupOverviewCreatedStats,
  GroupOverviewMemberStats,
  InternalOverviewStats,
  PostOverviewLikeStats,
  PostOverviewShareStats,
  ROIOverviewStats,
  ShareOverviewClickStats,
  ShareOverviewEngagementStats,
  TotalReachOverviewStats,
  UserOverviewPostStats,
  UserOverviewShareStats,
} from '../components/Analytics';

import { Capability } from 'components';

const AnalyticsOverview: FC = () => (
  <Grid container spacing={2}>
    <Grid xs={12} container>
      <Capability name="Admin.Analytics.ROI.View.Access">
        <Grid xs={12}>
          <ROIOverviewStats />
        </Grid>
      </Capability>
    </Grid>
    <Grid xs={12} container>
      <Grid xs={8}>
        <ExternalOverviewStats />
      </Grid>
      <Grid xs={4}>
        <TotalReachOverviewStats />
      </Grid>
    </Grid>
    <Grid xs={12} container>
      <Grid xs={12}>
        <InternalOverviewStats />
      </Grid>
    </Grid>
    <Grid container>
      <Grid xs={6}>
        <PostOverviewLikeStats />
      </Grid>
      <Grid xs={6}>
        <PostOverviewShareStats />
      </Grid>
    </Grid>
    <Grid container>
      <Grid xs={6}>
        <ShareOverviewClickStats />
      </Grid>
      <Grid xs={6}>
        <ShareOverviewEngagementStats />
      </Grid>
    </Grid>
    <Grid container>
      <Grid xs={6}>
        <UserOverviewShareStats />
      </Grid>
      <Grid xs={6}>
        <UserOverviewPostStats />
      </Grid>
    </Grid>
    <Grid container>
      <Grid xs={6}>
        <GroupOverviewMemberStats />
      </Grid>
      <Grid xs={6}>
        <GroupOverviewCreatedStats />
      </Grid>
    </Grid>
  </Grid>
);

export default AnalyticsOverview;
